import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
// @src imports
import buttonStyles from './gradientButtons.module.scss'
import styles from '../styles/components/Drawer.module.scss'
import { useEffect, useMutations, useState } from '../../hooks'

const UploadFooter: React.FC = () => {
  const [imageToUpload, setImageToUpload] = useState<File | null>()
  const [uploadPreview, setUploadPreview] = useState<
    string | ArrayBuffer | null
  >()

  const mutations = useMutations()

  useEffect(() => {
    ;(async () => {
      if (!imageToUpload) return

      try {
        await mutations.uploadImage({
          image_file: imageToUpload,
          tags: ['prompt-editor'],
        })
      } catch (error) {
        console.error(error)
      } finally {
        setImageToUpload(null)
        setUploadPreview(null)
      }
    })()
  }, [mutations, imageToUpload])

  return (
    <div className={styles.drawerBarBottom}>
      <div className={styles.uploadIcon}>
        {imageToUpload ? (
          <div className={styles.ImageUploading}>
            <img src={String(uploadPreview)} alt={'upload'} />
            <LinearProgress />
          </div>
        ) : (
          <label htmlFor="upload">
            <div
              className={`${buttonStyles.gradientButton} ${buttonStyles.pink} ${buttonStyles.basic}`}
              aria-hidden="true"
            >
              <span
                className={buttonStyles.inner}
                style={{ color: '#ff5689', lineHeight: '26px' }}
              >
                Upload A Photo
              </span>
            </div>
            <input
              id="upload"
              type="file"
              accept=".jpg, .jpeg, .png"
              onChange={event => {
                event.preventDefault()
                if (event.target.files == null) {
                  return
                }
                const file = event.target.files[0]
                setImageToUpload(file)
                const mutableReader = new FileReader()
                mutableReader.onloadend = () =>
                  setUploadPreview(mutableReader.result)
                mutableReader.readAsDataURL(file)
              }}
              style={{ display: 'none', lineHeight: 0 }}
            />
          </label>
        )}
      </div>
    </div>
  )
}

export default UploadFooter
